import React from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {connect} from "trim-redux";
import {Link, withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import withWidth from "@material-ui/core/withWidth/withWidth";
import Grid from "@material-ui/core/Grid/Grid";
import {Translate} from "../../../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import validator from "validator";
import axios from "axios";
import {defaultVariabls} from "../../../../../config";
import LoadingButton from "../../../../components/elements/LoadingButton";

import SaveRoundedIcon from '@material-ui/icons/SaveRounded';
import {LoadSetting} from "../../../../../config/Security";
import SingleFileChooser from "../../../fileManager/Components/SingleFileChooser";
import SiteColorPicker from "../../template/components/SiteColorPicker";
import CoverTypesField from "./components/CoverTypesField";
import SizesField from "./components/SizesField";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import Typography from "@material-ui/core/Typography/Typography";
import BanksField from "./components/BanksField";

class SiteSettings extends React.Component {
    classes = this.props.classes;
    state = {
        fields:{
            app_name: this.props.setting.app_name,
            publisher_limit: this.props.setting.publisher_limit,
            distribution_limit: this.props.setting.distribution_limit,
            virtual_store_limit: this.props.setting.virtual_store_limit,
            physical_store_limit: this.props.setting.physical_store_limit,
            normal_limit: this.props.setting.normal_limit,
            global_need_verification: this.props.setting.global_need_verification === 1 ? 1 : 0,
        },
        site_logo_file:this.props.setting.site_logo_file,
        site_logo_id:this.props.setting.site_logo_file.id,
        favicon_file:this.props.setting.favicon_file,
        favicon_id:this.props.setting.favicon_file.id,
        square_logo_file:this.props.setting.square_logo_file,
        square_logo_id:this.props.setting.square_logo_file.id,
        page_header_file:this.props.setting.page_header_file,
        page_header_id:this.props.setting.page_header_file.id,

        SubmitLoading:false,
        errors:{}
    };
    handleChange(e){
        let {errors,fields} = this.state;
        let target = e.target;
        fields[target.name] = target.value;
        errors[target.name] = "";
        this.setState({fields});
    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        //name
        if(validator.isEmpty(fields.app_name)){
            formIsValid = false;
            errors['app_name'] = Translate.emptyField;
        }

        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }

    handleRequest(){
        let { fields,site_logo_id,favicon_id,page_header_id,square_logo_id} = this.state;
        let data = new FormData();
        data.append('app_name', fields.app_name);
        data.append('normal_limit', fields.normal_limit);
        data.append('physical_store_limit', fields.physical_store_limit);
        data.append('virtual_store_limit', fields.virtual_store_limit);
        data.append('distribution_limit', fields.distribution_limit);
        data.append('publisher_limit', fields.publisher_limit);
        data.append('site_logo_id', site_logo_id);
        data.append('favicon_id', favicon_id);
        data.append('page_header_id', page_header_id);
        data.append('square_logo_id', square_logo_id);
        data.append('global_need_verification', fields.global_need_verification);


        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/settings/save`, data, config)
            .then(async response => {
                await LoadSetting();
                await this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
                await this.props.enqueueSnackbar(Translate.allChangesSaved, {
                    variant: 'success',
                });
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.allChangesSavingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
            });

    }
    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    handleChangeFile(field,val){
        if(!!val){
            if(field === "site_logo"){
                this.setState({
                    site_logo_id:val.id,
                    site_logo_file:val
                })
            }
            if(field === "square_logo"){
                this.setState({
                    square_logo_id:val.id,
                    square_logo_file:val
                })
            }
            if(field === "favicon"){
                this.setState({
                    favicon_id:val.id,
                    favicon_file:val
                })
            }
            if(field === "page_header"){
                this.setState({
                    page_header_id:val.id,
                    page_header_file:val
                })
            }
        }

    }
    handleChangeVerification(){
        let {fields} = this.state;
        if(fields.global_need_verification !== 1){
            fields['global_need_verification'] =  1;
        }else{
            fields['global_need_verification'] =  0;
        }
        this.setState({
            fields
        })
    }
    render(){
        let {errors,fields,SubmitLoading,site_logo_file,favicon_file,page_header_file,square_logo_file} = this.state;
        return (
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <TextField
                        variant="outlined"
                        value={fields.app_name}
                        fullWidth
                        size="small"
                        label={Translate.app_name}
                        name="app_name"
                        onChange={this.handleChange.bind(this)}
                        error = {!!errors['app_name']}
                        helperText={errors['app_name']}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        variant="outlined"
                        value={fields.publisher_limit}
                        fullWidth
                        size="small"
                        label={Translate.publisher_limit}
                        name="publisher_limit"
                        placeholder={Translate.limit_hint}
                        onChange={this.handleChange.bind(this)}
                        error = {!!errors['publisher_limit']}
                        helperText={errors['publisher_limit']}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        variant="outlined"
                        value={fields.distribution_limit}
                        fullWidth
                        size="small"
                        placeholder={Translate.limit_hint}
                        label={Translate.distribution_limit}
                        name="publisher_limit"
                        onChange={this.handleChange.bind(this)}
                        error = {!!errors['distribution_limit']}
                        helperText={errors['distribution_limit']}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        variant="outlined"
                        value={fields.physical_store_limit}
                        fullWidth
                        size="small"
                        placeholder={Translate.limit_hint}
                        label={Translate.physical_store_limit}
                        name="physical_store_limit"
                        onChange={this.handleChange.bind(this)}
                        error = {!!errors['physical_store_limit']}
                        helperText={errors['physical_store_limit']}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        variant="outlined"
                        value={fields.virtual_store_limit}
                        fullWidth
                        size="small"
                        placeholder={Translate.limit_hint}
                        label={Translate.virtual_store_limit}
                        name="virtual_store_limit"
                        onChange={this.handleChange.bind(this)}
                        error = {!!errors['virtual_store_limit']}
                        helperText={errors['virtual_store_limit']}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        variant="outlined"
                        value={fields.normal_limit}
                        fullWidth
                        size="small"
                        placeholder={Translate.limit_hint}
                        label={Translate.normal_limit}
                        name="normal_limit"
                        onChange={this.handleChange.bind(this)}
                        error = {!!errors['normal_limit']}
                        helperText={errors['normal_limit']}
                    />
                </Grid>
                {/*<Grid item xs={12} md={6}>
                    <SiteColorPicker/>
                </Grid>
                <Grid item xs={6} md={4} lg={3}>
                    <SingleFileChooser
                        title={Translate.site_logo}
                        initial={site_logo_file}
                        onChange={(file) => this.handleChangeFile('site_logo',file)}
                    />
                </Grid>
                <Grid item xs={6} md={4} lg={3}>
                    <SingleFileChooser
                        title={Translate.favicon}
                        initial={favicon_file}
                        onChange={(file) => this.handleChangeFile('favicon',file)}
                    />
                </Grid>
                <Grid item xs={6} md={4} lg={3}>
                    <SingleFileChooser
                        title={Translate.square_logo}
                        initial={square_logo_file}
                        onChange={(file) => this.handleChangeFile('square_logo',file)}
                    />
                </Grid>
                <Grid item xs={6} md={4} lg={3}>
                    <SingleFileChooser
                        title={Translate.page_header}
                        initial={page_header_file}
                        onChange={(file) => this.handleChangeFile('page_header',file)}
                    />
                </Grid>*/}
                <Grid item xs={12}>
                    <CoverTypesField/>
                </Grid>
                <Grid item xs={12}>
                    <SizesField/>
                </Grid>
                <Grid item xs={12}>
                    <BanksField/>
                </Grid>
                <Grid item xs={12}>
                    <Typography>
                        {Translate.globalNeedVerification}
                    </Typography>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={fields.global_need_verification}
                                onChange={() => this.handleChangeVerification()}
                                name="global_need_verification"
                            />
                        }
                        label={fields.global_need_verification ? Translate.yesGlobalNeedVerification : Translate.noGlobalNeedVerification}
                    />
                </Grid>
                <Grid item xs={12}>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        startIcon={<SaveRoundedIcon/>}
                        onClick={this.handleSubmit.bind(this)}
                        loading={SubmitLoading}
                    >
                        {Translate.saveChanges}
                    </LoadingButton>
                </Grid>
            </Grid>
        );
    }
}

const mstp = state => ({
    locale: state.locale,
    about: state.about,
    setting: state.setting,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(SiteSettings)))));